import { hbs } from 'ember-cli-htmlbars';
export default hbs("{{page-title \"Changelog\"}}\n\n<NwChangelog />")